var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.748,
    height: 37.748,
    viewBox: "0 0 37.748 37.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_share",
    "data-name": "vuesax/linear/share",
    transform: "translate(-364 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(364 316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0A13.573,13.573,0,0,1,5.757,9.673",
    transform: "translate(26.675 9.704)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,9.673A13.528,13.528,0,0,1,5.662,0",
    transform: "translate(5.489 9.783)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0A13.408,13.408,0,0,0,6.087,1.447,13.332,13.332,0,0,0,11.954.11",
    transform: "translate(12.882 32.935)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M8.745,4.372A4.372,4.372,0,1,1,4.372,0,4.372,4.372,0,0,1,8.745,4.372Z",
    transform: "translate(14.596 3.366)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M8.745,4.372A4.372,4.372,0,1,1,4.372,0,4.372,4.372,0,0,1,8.745,4.372Z",
    transform: "translate(3.224 22.586)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M8.745,4.372A4.372,4.372,0,1,1,4.372,0,4.372,4.372,0,0,1,8.745,4.372Z",
    transform: "translate(25.779 22.586)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H37.748V37.748H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/social_media.0120f803ef18b0f91b3d054b267b89bd.svg";
export { ForwardRef as ReactComponent };